<template>
  <div
    style="margin-top: 0px"

    @click="removeLists"
  >
    <div>
      <div
        class="table__header"
        :style="
          isactive == true
            ? 'justify-content: space-between; margin-bottom: 15px;'
            : 'justify-content: flex-end; margin-bottom: 15px'
        "
      >
        <div
          style="display: flex"
          class="filtering"
        >
          <div>
            <div class="black">
              <b-icon-search
                v-if="searchUser == ''"
                class="search1"
                style="position: absolute; left: 5px; top: 12px"
              />
              <b-icon-x-circle
                v-else-if="searchUser != '' && !noSearch"
                class="search1"
                style="position: absolute; right: 20px; top: 12px; cursor: pointer"
                @click="searchUser = ''"
              />
              <input
                v-model="searchUser"
                autocomplete="off"
                type="text"
                name="search-box"
                :placeholder="$t('FullName')"
                :style="
                  getFilteredActiveUsers.length > 0 ||
                    (getFilteredInactiveUsers.length > 0 && noSearch)
                    ? 'border-radius: 8px 8px 0px 0px'
                    : ''
                "
                @keyup="inputChanged"
                @keydown.down="onArrowDown"
                @keydown.up="onArrowUp"
              >
            </div>
            <div
              v-if="
                (getFilteredActiveUsers.length > 0 || getFilteredInactiveUsers.length > 0) &&
                  noSearch
              "
              ref="scrollContainer"
              class="dropdrop"
            >
              <div
                v-for="(result, index) in getFilteredActiveUsers.length > 0
                  ? getFilteredActiveUsers
                  : getFilteredInactiveUsers"
                :key="index"
                ref="options"
                style="cursor: pointer"
                class="search-item"
                :class="{ 'is-active': index === arrowCounter }"
                @click="
                  searchByOn(result);
                  noSearch = false;
                "
              >
                <p style="margin: 0">
                  {{ result.fullName }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style="width: 100%; padding-top: 16px; max-height: 895px; overflow-y: scroll;"
        class="scroll"
      >
        <table
          class="team_table"
        >
          <thead style="position: sticky; top: -17px">
            <tr>
              <th>
                {{ $t("No") }}
              </th>
              <th>
                {{ $t("FirstName") }}
              </th>
              <th>
                {{ $t("LastName") }}
              </th>
              <!-- <th style="padding: 10px; text-align: center">
                {{ $t("VacationCreatedD") }}
              </th> -->
              <!-- <th style="padding: 10px; text-align: center">
                {{ $t("VacationEmployeeT") }}
              </th> -->
              <th
                v-if="isactive == true"
                style="cursor: pointer;"
                @click="sortByRole"
              >
                {{ $t("Role") }}
                <b-icon-sort-alpha-up-alt v-if="sortedR == false" />
                <b-icon-sort-alpha-down v-else />
              </th>
              <th
                v-else
                style="cursor: pointer"
                @click="sortByRoleI"
              >
                {{ $t("Role") }}
                <b-icon-sort-alpha-down v-if="sortedRI == false" />
                <b-icon-sort-alpha-up-alt v-else />
              </th>
              <!-- <th style="padding: 10px; border-radius: 0px 0px 0px 0px; text-align: center">
                {{ $t("Filiale") }}
              </th> -->
              <th>
                {{ $t("Rating") }}
              </th>
              <!-- <th style="padding: 10px; border-radius: 0px 0px 0px 0px; text-align: center">
                {{ $t("VacationDays") }}
              </th>
              <th style="padding: 10px; border-radius: 0px 0px 0px 0px; text-align: center">
                {{ $t("EditVD") }}
              </th>
              <th style="padding: 10px; border-radius: 0px 0px 0px 0px; text-align: center">
                {{ $t("VacationLeaveReq") }}
              </th> -->
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(user, index) in filteredUsers"
              :key="index"
              v-b-tooltip.hover.bottom
              style="cursor: pointer; text-align: center;"
              :title="getLanguage == 'en' ? `${$t('ClickFor') +' '+ user.firstName +' '+ user.lastName +' '+ $t('Feedback')}` : `${$t('FeedbackDetails') +' '+ user.firstName +' '+ user.lastName}`"
              @click="matProps(user), showSameId(user.userId)"
            >
              <td>
                {{ getTotalItemsForUsers - (page - 1) * pageSize - index }}.
              </td>
              <td>
                {{ user.firstName }}
              </td>
              <td>
                {{ user.lastName }}
              </td>
              <!-- <td style="padding: 9px">
                {{ dateModified(user.created) }}
              </td> -->
              <!-- <td
                v-if="user.employeeType === 'Internal'"
                style="padding: 9px"
              >
                {{ $t("Internal") }}
              </td>
              <td
                v-else
                style="padding: 9px"
              >
                {{ $t("External") }}
              </td> -->
              <td>
                <button id="button">
                  {{ $t(user.role) }}
                </button>
              </td>
              <!-- <td style="padding: 9px">
                {{ user.storeName }}
              </td> -->
              <td
                style="display: flex; justify-content: center;"
                @click.stop
              >
                <b-form>
                  <b-form-rating
                    v-model="user.rangingValue"

                    v-b-tooltip.hover.top="$t('Rating') +' '+ nameToShow(user.rangingValue) "
                    variant="warning"
                    class="mb-2"
                    readonly
                  />
                </b-form>
              </td>
              <!-- <td style="padding: 9px">
                {{ user.remainingDays }} / {{ user.totalDays }}
              </td>
              <td style="padding: 9px">
                <b-button
                  v-if="user.storeName != null || user.personRole == 'Manager'"
                  v-b-modal.add-edit-vacation-days
                  style="height:34px; font-size: small; background: #FF274F;"
                  @click="saveUser(user), loadRemainingDays(user.userId)"
                >{{ $t("EditVD") }}</b-button>
              </td>
              <td style="padding: 3px">
                <b-button
                  v-if="user.storeName != null || user.personRole == 'Manager'"
                  v-b-modal.leave-request
                  style="height:34px; font-size: small; background: #FF274F;"
                  @click="saveUser(user)"
                >{{ $t("VacationLeaveReq") }}</b-button>
              </td> -->
            </tr>
            <div style="margin: 10px;">
              <button
                v-if="selectedId != null"
                class="button"
                style="font-size: 16px;"
                @click="showAll"
              >
                {{ $t("ViewAll") }}
              </button>
            </div>
          </tbody>
        </table>
      </div>
      <div>
        <b-pagination
          v-if="isactive == true && getTotalItemsForUsers > 15"
          v-model="page"
          :total-rows="getTotalItemsForUsers"
          :per-page="pageSize"
          first-number
          last-number
          :hidden="selectedId"
          align="fill"
          prev-class="prev-itemi"
          next-class="next-itemi"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span>{{ $t("Previous") }}</span>
          </template>
          <template #next-text>
            <span>{{ $t("Next") }}</span>
          </template>
        </b-pagination>
        <b-pagination
          v-else-if="isactive == false && getTotalItemsForInActiveUsers > 15"
          v-model="page"
          :total-rows="getTotalItemsForInActiveUsers"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span>{{ $t("Previous") }}</span>
          </template>
          <template #next-text>
            <span>{{ $t("Next") }}</span>
          </template>
        </b-pagination>
      </div>
    </div>
    <!-- @pushFormUser="AddEditVacation" -->
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';


export default {
  components: {

  },
  props: {
    users: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      userObj: {},
      showOtherComponent: false,
      isactive: true,
      searchUser: '',
      noSearch: false,
      sortedR: false,
      sortedRI: false,
      selectedId: null,
      editUser: {
        userId: '',
        firstName: '',
        lastName: '',
        salutation: '',
        gender: '',
        city: '',
        dateOfBirth: '',
        phoneNumber: '',
        postalCode: '',
        doorNumber: '',
        street: '',
        country: '',
        email: '',
        role: '',
        resetPassword: false,
      },
      deactivateItemId: {},
      activateItemId: {},
      totalItems: '',
      page: 1,
      pageSize: 15,
      status: true,
      arrowCounter: 0,
      enterPressed: false,
      employeeId: null,
    };
  },
  computed: {
    ...mapGetters([
      'getEmployeeFeedbackPagination',
      'getInactiveUsers',
      'getFilteredActiveUsers',
      'getFilteredInactiveUsers',
      'getTotalItemsForUsers',
      'getTotalItemsForInActiveUsers',
      'getFeedback',
      'getLanguage',
    ]),
    filteredUsers() {
      // filter the users array to only show rows with the same id as the selected id
      return this.selectedId
        ? this.getEmployeeFeedbackPagination.filter((getEmployeeFeedbackPagination) => {
          return getEmployeeFeedbackPagination.userId === this.selectedId;
        })
        : this.getEmployeeFeedbackPagination;
    },
  },
  watch: {
    page(value) {
      if (this.isactive) {
        this.loadEmployeeFeedbackPagination({
          firstName: this.searchUser,
          pageNumber: value,
          pageSize: this.pageSize,
        });
      }
    },
    searchUser(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        this.selectedId = null;
        if (value == '') {
          this.removeLists();
          if (this.isactive) {
            this.loadEmployeeFeedbackPagination({
              firstName: value,
              pageNumber: this.page,
              pageSize: this.pageSize,
            });
          } else if (this.enterPressed) {
          // eslint-disable-next-line no-useless-return
            return;
          } else {
            this.getInactiveUsersPagination({
              status: false,
              pageNumber: this.page,
              pageSize: this.pageSize,
              fullName: value,
            });
          }
        } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
          return;
        } else if (this.isactive) {
          this.filterActiveUsersByName(value);
        } else {
          this.filterInactiveUsersByName(value);
        }
        this.noSearch = true;
      }, 500)
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    ...mapActions([
      'loadEmployeeFeedbackPagination',
      'getInactiveUsersPagination',
      'filterActiveUsersByName',
      'resetFilteredActiveUsers',
      'filterInactiveUsersByName',
      'resetFilteredInactiveUsers',
      'changeLoadingtoTrue',
      'loadVacationRequests',
      'assignEmployeeToStoree',
      'leaveRequest',
      'remainingDaysOfEmployee',
      'filterActiveUsersByName',
      'loadFeedback',
      'loadEmployeeFeedbackPagination',
    ]),
    async fetch() {
      try {
        // this.changeLoadingtoTrue(false);

        await this.loadEmployeeFeedbackPagination({
          firstName: null,
          lastName: null,
          pageNumber: this.page,
          pageSize: this.pageSize,
        }).then(() => {
          // this.changeLoadingtoTrue(true);
        });
      } catch (e) {
        console.log(e);
        // this.changeLoadingtoTrue(false);
      }
    },
    matProps(users) {
      this.$emit('click', users);
      this.classNameCh = users.userId;
      this.$emit('show-the-component');
      this.loadFeedback({ userId: users.userId, year: moment().format('YYYY') })
    },
    loadRemainingDays(value) {
      const currentYear = new Date().getFullYear();
      this.remainingDaysOfEmployee({ employeeUserId: value, year: currentYear });
    },
    async assignEmployeeToFiliale(obj) {
      await this.assignEmployeeToStoree({
        object: obj,
        successCallback: () => {
          this.loadEmployeeFeedbackPagination({
            pageNumber: this.page,
            pageSize: this.pageSize,
          });
        },
      });
    },
    showSameId(id) {
      // set the selected id to the id of the clicked row
      this.selectedId = id;
    },
    loadFeedbackk(id) {
      // console.log('testt', id.userId)
      const currentYear = new Date().getFullYear();
      this.loadFeedback({ userId: id.userId, year: currentYear })
    },
    showAll() {
      // set the selected id to null to show all rows
      this.selectedId = null;
      this.$emit('show-other-component');
    },

    dateModified(xdate) {
      return moment(xdate).format('DD/MM/YYYY');
    },
    onArrowDown(ev) {
      ev.preventDefault();
      if (this.arrowCounter < this.getFilteredActiveUsers.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUp(ev) {
      ev.preventDefault();
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling();
      }
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') {
        return;
      }
      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true;
        this.searchByOn(this.getFilteredActiveUsers[this.arrowCounter]);
        this.removeLists();
        this.arrowCounter = 0;
        setTimeout(() => {
          this.enterPressed = false;
        }, 1000);
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      // console.log(liH);
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    sortByRole() {
      if (this.sortedR == false) {
        this.getEmployeeFeedbackPagination.sort((a, b) => {
          return a.role.localeCompare(b.role);
        });
        this.sortedR = true;
      } else {
        this.getEmployeeFeedbackPagination.sort((a, b) => {
          return a.role > b.role ? -1 : 1;
        });
        this.sortedR = false;
      }
    },
    sortByRoleI() {
      if (this.sortedRI == false) {
        this.getInactiveUsers.sort((a, b) => {
          return a.role.localeCompare(b.role);
        });
        this.sortedRI = true;
      } else {
        this.getInactiveUsers.sort((a, b) => {
          return a.role > b.role ? -1 : 1;
        });
        this.sortedRI = false;
      }
    },
    nameToShow(value) {
      if (value > 0) {
        return value
      }
      return '0'
    },
    async searchByOn(value) {
      const fullName = value.fullName;
      const spaceIndex = fullName.indexOf(' ');
      let firstName; let
        lastName;

      if (spaceIndex !== -1) {
        // Split the fullName into firstName and lastName
        firstName = fullName.slice(0, spaceIndex);
        lastName = fullName.slice(spaceIndex + 1);
      } else {
        // If there is no space, assume the entire name is the firstName
        firstName = fullName;
        lastName = ''; // You can set this to an empty string or handle it differently
      }

      this.searchUser = fullName;
      this.noSearch = false;
      await this.loadEmployeeFeedbackPagination({
        firstName,
        lastName,
        pageNumber: this.page,
        pageSize: this.pageSize,
      });
    },
    removeLists() {
      this.noSearch = false;
      this.resetFilteredActiveUsers();
      this.resetFilteredInactiveUsers();
    },
  },
};
</script>

<style scoped>

.team_table td {
  padding: 16px 9px !important;
}

.team_table th {
  text-align: center;
}
.button {
  width: 195px;
}

.viewAllBtn{
  background: #FF274F;
}
.addEmployeeButton {
  width: 210px;
}

#button {
  width: fit-content;
  height: 22px;
  background: #EAEDFB;
  color: #242F6E;
  font-weight: 500;
  font-size: 12px;
  border: 1px solid #242F6E;
  border-radius: 1000px;
  cursor: default;
}

.mb-2{
  border: none;
  display: flex;
  align-items: center;
  margin: 0px;
  padding: 0px;
}

@media screen and (max-width: 1600px) {
  .scroll {
    overflow-x: scroll;
  }
}

@media screen and (max-width: 1110px) {
  .button {
    margin-right: 10px;
    font-size: 12px;
    height: 36px;
    width: 150px;
  }
}

.dropdrop::-webkit-scrollbar {
  display: none;
}
.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: none;;
  z-index: 3;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}
.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}

.search-item:last-child {
  border-bottom: none;
}

.search-item:hover {
  background: #82868c;
  color: white;
}

.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}

@media screen and (max-width: 763px) {
  .con {
    flex-wrap: wrap;
  }

  .active-inactive-con {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .button {
    height: auto;
  }
}

.is-active {
  background-color: #dedede;
}
</style>
